import { EventEmitter } from '@angular/core';
import { Control, DomEvent, DomUtil } from 'leaflet';

export const CustomZoomControl = Control.Zoom.extend({
	_zoomLevel: null as any,
	zoomToWindowButtonClicked: new EventEmitter<void>(),
	gpsHomeButtonClicked: new EventEmitter<void>(),
	homeButtonClicked: new EventEmitter<void>(),
	selectionButtonClicked: new EventEmitter<void>(),

	_updateZoomLevel: function(zoom: number) {
		this._zoomLevel.innerHTML = zoom.toFixed(1);
	},

	onAdd: function(map: L.Map) {
		const container = Control.Zoom.prototype.onAdd?.call(this, map);

		const zoomToWindowBtn = DomUtil.create('a', 'leaflet-control-zoom-window', container);
		zoomToWindowBtn.innerHTML = '<i class="bi bi-aspect-ratio"></i>';
		zoomToWindowBtn.href = '#';
		zoomToWindowBtn.title = 'Auf Ausschnitt zoomen';

		DomEvent.on(zoomToWindowBtn, 'click', (e: Event) => {
			DomEvent.preventDefault(e);
			DomEvent.stopPropagation(e);
			this.zoomToWindowButtonClicked.emit();
		});

		this._zoomLevel = DomUtil.create('div', 'leaflet-control-zoom-level', container);
		this._updateZoomLevel(map.getZoom());
		map.on('zoomend', () => this._updateZoomLevel(map.getZoom()));

		const gpsHomeBtn = DomUtil.create('a', 'leaflet-control-zoom-home', container);
		gpsHomeBtn.innerHTML = '<i class="bi bi-geo-fill"></i>';
		gpsHomeBtn.href = '#';
		gpsHomeBtn.title = 'Neu zentrieren';

		DomEvent.on(gpsHomeBtn, 'click', (e: Event) => {
			DomEvent.preventDefault(e);
			DomEvent.stopPropagation(e);
			this.gpsHomeButtonClicked.emit();
		});

		const homeBtn = DomUtil.create('a', 'leaflet-control-zoom-fit', container);
		homeBtn.innerHTML = '<i class="bi bi-house"></i>';
		homeBtn.href = '#';
		homeBtn.title = 'Auf Bearbeitungsbereich zoomen';

		DomEvent.on(homeBtn, 'click', (e: Event) => {
			DomEvent.preventDefault(e);
			DomEvent.stopPropagation(e);
			this.homeButtonClicked.emit();
		});

		const selectionBtn = DomUtil.create('a', 'leaflet-control-zoom-selection', container);
		selectionBtn.innerHTML = '<i class="bi bi-check2-square"></i>';
		selectionBtn.href = '#';
		selectionBtn.title = 'Auf Auswahl zoomen';

		DomEvent.on(selectionBtn, 'click', (e: Event) => {
			DomEvent.preventDefault(e);
			DomEvent.stopPropagation(e);
			this.selectionButtonClicked.emit();
		});

		return container;
	}
});
